import type { FC } from 'react'
import { memo } from 'react'
import Image from 'next/image'
import styled from 'styled-components'
import type { TypeMedia } from '@/schema'

type TypeFigure = {
  readonly media: TypeMedia,
  readonly lazy?: boolean,
  readonly initialInView?: boolean,
  onClick?: any,
  readonly fill?: boolean,
  readonly outRef?: (node?: Element) => void,
  readonly className?: string,
  readonly sizes?: any,
  readonly quality?: number
}

const FigureStyled = styled.figure<any>`
  display: block;
  position: relative;
`

export const Figure: FC<TypeFigure> = memo(({ media, lazy = true, fill = true, onClick = null, className = '', outRef = null, sizes = '70vw', quality = 75}) => {
  const isMobile = false
  if (!media) return <figure className='placeholder' />
  else if (media.type === 'svg') return (
    <FigureStyled className={className} {...onClick && { onClick }}  {...outRef && { ref: outRef }}>
      <Image src={media.src} alt={media.alt}
        layout={fill ? 'fill' : 'responsive'}
        {...!lazy && { priority: true }}
        {...!fill && { height: media.size.height }}
        {...!fill && { width: media.size.width }}
      />
    </FigureStyled>
  )

  return (
    <FigureStyled className={className} {...onClick && { onClick }}  {...outRef && { ref: outRef }}>
      {/* {inView && */}
      <Image
        src={media?.[(isMobile && media?.mobile) ? 'mobile' : 'default']?.src}
        alt={media?.alt}
        layout={fill ? 'fill' : 'responsive'}
        {...!lazy && { priority: true }}
        {...!fill && { height: media?.[(isMobile && media?.mobile) ? 'mobile' : 'default']?.size?.height }}
        {...!fill && { width: media?.[(isMobile && media?.mobile) ? 'mobile' : 'default']?.size?.width }}
        sizes={sizes}
        {...quality !== 75 && { quality }}
      />
    </FigureStyled>
  )
})
